import Swiper from 'swiper';

export function initializeCarousels() {
    // If you need to initialize swiper with a different look then you can add a new configuration with a different class here

    let swiperContainers = document.getElementsByClassName('swiper-container');
    [].forEach.call(swiperContainers, (swiperContainer: HTMLElement) => {
        new Carousel(swiperContainer);
    });
}

const MobileBreakpoint = 400;
const TabletBreakpoint = 640;
const DesktopBreakpoint = 992;

// breakpoint where swiper will be destroyed
// and switches to a dual-column layout
const Breakpoint = window.matchMedia(`(min-width:${TabletBreakpoint}px)`);

export class Carousel {
    swiperContainer: HTMLElement;
    swiper: Swiper;

    constructor(swiperContainer: HTMLElement) {
        this.swiperContainer = swiperContainer;

        if (this.mobileOnly) {
            // keep an eye on viewport size changes
            Breakpoint.addListener(this.handleBreakpoint);
            // kickstart
            this.handleBreakpoint();
        }
        else {
            this.initSwiper();
        }
    }

    handleBreakpoint = () => {
        // if larger viewport and multi-row layout needed
        if (Breakpoint.matches === true) {
            // clean up old instances and inline styles when available
            if (this.swiper) this.swiper.destroy(true, true);
            // or/and do nothing
            return;
            // else if a small viewport and single column layout needed
        } else if (Breakpoint.matches === false) {
            // fire small viewport version of swiper
            this.initSwiper();
        }
    }

    initSwiper = () => {
        this.swiper = new Swiper(this.swiperContainer, {
            centeredSlides: this.centeredSlides,
            loop: this.loop,
            slidesPerView: this.slidesPerViewMobile,
            slidesPerGroup: this.slidesPerGroupMobile,
            watchSlidesVisibility: this.watchSlidesVisibility,
            spaceBetween: 10,
            breakpoints: {
                400: {
                    slidesPerView: this.slidesPerViewSmall,
                    slidesPerGroup: this.slidesPerGroupSmall,
                },
                640: {
                    slidesPerView: this.slidesPerViewTablet,
                    slidesPerGroup: this.slidesPerGroupTablet,
                },
                768: {
                    slidesPerView: this.slidesPerView,
                    slidesPerGroup: this.slidesPerGroup,
                    
                },
                1024: {
                    slidesPerView: this.slidesPerView,
                    slidesPerGroup: this.slidesPerGroup,
                    spaceBetween: 20,
                },
            },
            

            pagination: {
                el: this.swiperContainer.querySelector('.swiper-pagination'),
                clickable: false,
                type: "fraction"
            },
            navigation: {
                nextEl: this.swiperContainer.querySelector('.swiper-button-next'),
                prevEl: this.swiperContainer.querySelector('.swiper-button-prev'),
            }
        });
    }

    get slidesPerViewAttribute() {
        return this.swiperContainer.getAttribute("data-swiper-slides-per-view");
    }

    get slidesPerViewTabletAttribute() {
        return this.swiperContainer.getAttribute("data-swiper-slides-per-view-tablet");
    }
    get slidesPerViewSmallAttribute() {
        return this.swiperContainer.getAttribute("data-swiper-slides-per-view-small");
    }
    get slidesPerViewMobileAttribute() {
        return this.swiperContainer.getAttribute("data-swiper-slides-per-view-mobile");
    }

    get slidesPerView() {
        return this.slidesPerViewAttribute
            ? parseInt(this.slidesPerViewAttribute)
            : 1;
    }

    get slidesPerViewTablet() {
        return this.slidesPerViewTabletAttribute
            ? parseInt(this.slidesPerViewTabletAttribute)
            : 1;
    }
    get slidesPerViewSmall() {
        return this.slidesPerViewSmallAttribute
            ? parseInt(this.slidesPerViewSmallAttribute)
            : 1;
    }

    get slidesPerViewMobile() {
        return this.slidesPerViewMobileAttribute
            ? parseInt(this.slidesPerViewMobileAttribute)
            : 1;
    }

    get slidesPerGroup() {
        return this.swiperContainer.getAttribute("data-swiper-slides-per-group")
            ? parseInt(this.swiperContainer.getAttribute("data-swiper-slides-per-group"))
            : 1;
    }

    get slidesPerGroupTablet() {
        return this.swiperContainer.getAttribute("data-swiper-slides-per-group-tablet")
            ? parseInt(this.swiperContainer.getAttribute("data-swiper-slides-per-group-tablet"))
            : 1;
    }
    get slidesPerGroupSmall() {
        return this.swiperContainer.getAttribute("data-swiper-slides-per-group-small")
            ? parseInt(this.swiperContainer.getAttribute("data-swiper-slides-per-group-small"))
            : 1;
    }

    get slidesPerGroupMobile() {
        return this.swiperContainer.getAttribute("data-swiper-slides-per-group-mobile")
            ? parseInt(this.swiperContainer.getAttribute("data-swiper-slides-per-group-mobile"))
            : 1;
    }

    get centeredSlides() {
        return this.swiperContainer.getAttribute("data-swiper-centered-slides")
            ? this.swiperContainer.getAttribute("data-swiper-centered-slides") === 'true'
            : true;
    }

    get watchSlidesVisibility() {
        return this.slidesPerViewAttribute && this.slidesPerView > 1;
    }

    get loop() {
        return this.swiperContainer.getAttribute("data-swiper-loop")
            ? this.swiperContainer.getAttribute("data-swiper-loop") === 'true'
            : true;
    }

    get mobileOnly() {
        return this.swiperContainer.hasAttribute("data-swiper-mobile-only");
    }

}
